import React, { PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Tabs, Tab, Row, Col, Container } from "react-bootstrap";

import TabDetalle from "./TabDetalle.jsx";
import TabParametros from "./TabParametros.jsx";
import ModalSeguridad from "../../Seguridad/ModalSeguridad.jsx";
import { Obtener_Estado_Active_Directory_Request } from '../../../request/ParametroRequest';
import { Obtener_MenuOpciones } from "../../../request/MenuRequest";
import { Notificacion } from "../../../components/Util/Notificacion/Notificacion.js";

class CallCenterMantenimiento extends PureComponent {
    _isMounted = false;
    state = {
        activoAD: false,
        tituloTab1: "",
        tituloTab2: "",
        menuId: 0,
        menuOpciones: [],
        showModalSeguridad: false,
        opcionValidar: 0,
        opcionSeleccionada: 1,
        Id: 0,
        CadenaId: 0,
        tabActivo: 1
    }

    componentDidMount = async () => {
        this._isMounted = true;

        const Id = this.props.match.params.id;
        let menuId = 0;
        if (this.props.location.state) {
            menuId = this.props.location.state.menuId;
        }

        this.obtenerMenuOpciones(menuId);        
        this.obtenerEstadoActiveDirectory();
        this.setState({ Id });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    obtenerMenuOpciones = async (pMenu_Id) => {
        if (pMenu_Id > 0) {

            const response = await Obtener_MenuOpciones(this.props.token, pMenu_Id);
            if (response.Exitoso) {

                let tituloTab1 = "";
                let tituloTab2 = "";
                if (response.Datos.length > 0) {
                    tituloTab1 = response.Datos[0].Nombre;
                }

                if (response.Datos.length > 1) {
                    tituloTab2 = response.Datos[1].Nombre;
                }

                this._isMounted && this.setState({ menuId: pMenu_Id, menuOpciones: response.Datos, tituloTab1, tituloTab2 });
            } else {
                Notificacion.error(response.Mensaje);
            }
        }
    }

    guardarId = (Id) => {
        this._isMounted && this.setState({ Id });
    }

    guardarCadenaId = (CadenaId) => {
        this._isMounted && this.setState({ CadenaId });
    }

    handleTabClick = (id) => {
        const menuOpciones = this.state.menuOpciones;
        const resultado = menuOpciones.filter(item => item.Opcion_Id == id);

        if (resultado.length > 0) {
            if (resultado[0].Validar) {
                this._isMounted && this.setState({ showModalSeguridad: true, opcionValidar: resultado[0].Opcion_Id, tabActivo: 1 });
            } else {
                this._isMounted && this.setState({ tabActivo: id });
            }
        } else {
            this._isMounted && this.setState({ showModalSeguridad: true, opcionValidar: id, tabActivo: 1 });
        }
    }

    onActionResultModal = (pValido) => {
        if (pValido) {
            const opcionValidar = this.state.opcionValidar;
            this.setState({ showModalSeguridad: false, opcionSeleccionada: opcionValidar, opcionValidar: 0 },
                () => {
                    this._isMounted && this.setState({ tabActivo: opcionValidar });
                }
            );
        } else {
            this._isMounted && this.setState({ tabActivo: 1 });
        }
    }

    obtenerEstadoActiveDirectory = async () => {
        const response = await Obtener_Estado_Active_Directory_Request();
        if (response.Exitoso) {
            this.setState({ activoAD: response.Datos });
        }
        else {
            Notificacion.error(response.Mensaje);
        }
    }   

    render() {
        const { Id, CadenaId, tituloTab1, tituloTab2, showModalSeguridad, opcionValidar, menuId, tabActivo } = this.state;

        return (
            <div className="main">
                <Container>
                    <Row>
                        <Col>
                            <h1>{Id > 0 ? "Modificar Call Center" : "Nuevo Call Center"}</h1>
                        </Col>
                    </Row>
                    <div className="content-bg">
                        <Tabs
                            defaultActiveKey="1"
                            activeKey={tabActivo}
                            id="CallCenterDetalle"
                            onSelect={this.handleTabClick}
                        >
                            <Tab eventKey="1" title={tituloTab1}>
                                <TabDetalle
                                    guardarId={this.guardarId}
                                    guardarCadenaId={this.guardarCadenaId}
                                    Id={this.props.match.params.id > 0 ? this.props.match.params.id : Id}
                                />
                            </Tab>
                            <Tab
                                eventKey="2"
                                title={tituloTab2}
                                disabled={Id == 0}
                            >
                                <TabParametros
                                    Id={this.props.match.params.id > 0 ? this.props.match.params.id : Id}
                                    CadenaId={CadenaId}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                </Container>
                <ModalSeguridad
                    token={this.props.token}
                    menuId={menuId}
                    opcionId={opcionValidar}
                    show={showModalSeguridad}
                    onActionResult={this.onActionResultModal}
                    onHide={() => this.setState({ showModalSeguridad: false })}
                    activoAD={this.state.activoAD}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa
    };
};

export default connect(mapStateToProps)(withRouter(memo(CallCenterMantenimiento)));
